<div *ngIf="loadComplete" class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- <button nz-button nzType="primary" (click)="openModalEdit()">{{'chinh_sua_noi_dung' | translate}}</button> -->

      <ng-container *ngIf="objectChoosing.component == 'AtwFrameDisplaySubcategory'">
        <!-- Chọn nguồn lấy dữ liệu -->
        <div class="mb-2">
          <p class="mb-0">{{ 'nguon_lay_du_lieu'| translate }}</p>
          <nz-select class="w-100" [ngModel]="config.data_source_type" 
          (ngModelChange)="config.data_source_type = $event; updateConfig()">
            <nz-option [nzValue]="'menu'" nzLabel="{{'Menu' | translate}}"></nz-option>
            <nz-option [nzValue]="'link-now'" nzLabel="{{'duong_dan_trang_hien_tai'| translate}}"></nz-option>
            <!-- <nz-option [nzValue]="'all'" nzLabel="{{'tat_ca'| translate}}"></nz-option> -->
          </nz-select>
        </div>
  
        <!-- Chọn kiểu hiển thị dữ liệu -->
        <ng-container *ngIf="config.data_source_type == 'link-now'">
          <div>
            <p class="mb-0">{{ 'kieu_hien_thi_du_lieu'| translate }}</p>
            <nz-select class="w-100" [ngModel]="config.data_display_type" 
            (ngModelChange)="config.data_display_type = $event; updateConfig()">
              <nz-option [nzValue]="'parent_category'" nzLabel="{{'danh_muc_con' | translate}}"></nz-option>
              <nz-option [nzValue]="'same_category'" nzLabel="{{'danh_muc_cung_cap'| translate}}"></nz-option>
            </nz-select>
          </div>
          <ng-container *ngIf="config.data_display_type == 'same_category'">
            <div class="d-flex justify-content-between align-items-center mt-2">
              <span>{{'hien_thi_danh_muc_hien_tai' | translate}}</span>
              <nz-switch [ngModel]="config.data_type_same_category?.is_visible_current_category"
              (ngModelChange)="config.data_type_same_category.is_visible_current_category = $event; updateConfig()">
              </nz-switch>
            </div>
            <ng-container *ngIf="config.data_type_same_category?.is_visible_current_category">
              <div class="d-flex justify-content-between align-items-center mt-2">
                <span>{{'danh_muc_hien_tai_luon_o_dau' | translate}}</span>
                <nz-switch [ngModel]="config.data_type_same_category?.is_current_category_pinned"
                (ngModelChange)="config.data_type_same_category.is_current_category_pinned = $event; updateConfig()">
                </nz-switch>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-2">
                <span>{{'mo_cau_hinh_active' | translate}}</span>
                <nz-switch [ngModel]="config.data_type_same_category?.is_highlight_active"
                (ngModelChange)="config.data_type_same_category.is_highlight_active = $event; updateConfig()">
                </nz-switch>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <app-total-row-col-products-config [config]="config" [class]="class"
        [productsClass]="class['frame-categories__products']" [productsConfig]="config['frame-categories__products']"
        [id_object]="objectChoosing._id" [device]="device">
      </app-total-row-col-products-config>

      <!-- Khoảng đệm -->
      <div>
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['frame-categories__products']" [paddingConfigs]="[
                                  { type: 'top' },
                                  { type: 'bottom' },
                                  { type: 'left' },
                                  { type: 'right' }
                                ]">
        </app-padding-config>
      </div>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">

    <div style="margin-top: 10px"></div>
    <ul nz-menu nzMode="inline">    
      <!-- Nguồn dữ liệu -->
      <li *ngIf="objectChoosing.component == 'AtwFrameDisplaySubcategory'" nz-submenu nzTitle="{{'nguon_du_lieu' | translate}}" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <!-- Chọn nguồn lấy dữ liệu -->
        <div class="mb-2">
          <p class="mb-0">{{ 'nguon_lay_du_lieu'| translate }}</p>
          <nz-select class="w-100" [ngModel]="config.data_source_type" 
          (ngModelChange)="config.data_source_type = $event; updateConfig()">
            <nz-option [nzValue]="'menu'" nzLabel="{{'Menu' | translate}}"></nz-option>
            <nz-option [nzValue]="'link-now'" nzLabel="{{'duong_dan_trang_hien_tai'| translate}}"></nz-option>
            <!-- <nz-option [nzValue]="'all'" nzLabel="{{'tat_ca'| translate}}"></nz-option> -->
          </nz-select>
        </div>
  
        <!-- Chọn kiểu hiển thị dữ liệu -->
        <ng-container *ngIf="config.data_source_type == 'link-now'">
          <div>
            <p class="mb-0">{{ 'kieu_hien_thi_du_lieu'| translate }}</p>
            <nz-select class="w-100" [ngModel]="config.data_display_type" 
            (ngModelChange)="config.data_display_type = $event; updateConfig()">
              <nz-option [nzValue]="'parent_category'" nzLabel="{{'danh_muc_con' | translate}}"></nz-option>
              <nz-option [nzValue]="'same_category'" nzLabel="{{'danh_muc_cung_cap'| translate}}"></nz-option>
            </nz-select>
          </div>
          <ng-container *ngIf="config.data_display_type == 'same_category'">
            <div class="d-flex justify-content-between align-items-center mt-2">
              <span>{{'hien_thi_danh_muc_hien_tai' | translate}}</span>
              <nz-switch [ngModel]="config.data_type_same_category?.is_visible_current_category"
              (ngModelChange)="config.data_type_same_category.is_visible_current_category = $event; updateConfig()">
              </nz-switch>
            </div>
            <ng-container *ngIf="config.data_type_same_category?.is_visible_current_category">
              <div class="d-flex justify-content-between align-items-center mt-2">
                <span>{{'danh_muc_hien_tai_luon_o_dau' | translate}}</span>
                <nz-switch [ngModel]="config.data_type_same_category?.is_current_category_pinned"
                (ngModelChange)="config.data_type_same_category.is_current_category_pinned = $event; updateConfig()">
                </nz-switch>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-2">
                <span>{{'mo_cau_hinh_active' | translate}}</span>
                <nz-switch [ngModel]="config.data_type_same_category?.is_highlight_active"
                (ngModelChange)="config.data_type_same_category.is_highlight_active = $event; updateConfig()">
                </nz-switch>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </li>  
      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu9" (nzOpenChange)="openHandler('menu9')">
        <div class="main-config">
          <!-- Option màu nền cho frame -->
          <app-background-image-config [showImageConfig]="false"
                [config]="config"
                [class]="class"
                [backgroundClass]="class['frame-categories']"
                [backgroundConfig]="config['frame-categories']"
                [isBlock]="false"
                [id_object]="objectChoosing._id"
                [device]="device">
          </app-background-image-config>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          " *ngIf="config['frame-categories'].option_background == 'color'">
            <p class="discover_text" (click)="openViewAll(stylesField[5])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
          <!-- Thay đổi màu thẻ chứa cụm nút phân trang-->
          <div *ngIf="config.type_display == 'pagination'"  class="config-name">
            <p>{{'mau_nen_cum_nut_phan_trang' | translate}}</p>
            <input class="input-color"  type="button"
              [style.background]="class['frame-categories__pagination']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <div class="item">
            <div class="title-font d-flex align-items-center">{{'kieu_hien_thi'| translate}}</div>
            <nz-select style="width: 100px" [(ngModel)]="config.type_display" (ngModelChange)="updateConfig()">
              <nz-option [nzValue]="'slide'" nzLabel="{{'vuot' | translate}}"></nz-option>
              <nz-option [nzValue]="'pagination'" nzLabel="{{'phan_trang'| translate}}"></nz-option>
              <nz-option [nzValue]="'resize'" nzLabel="{{'gian_ra_theo_noi_dung'| translate}}"></nz-option>
            </nz-select>
          </div>
          <ng-container *ngIf="config.type_display == 'slide'">
            <!-- Cho phép slide -->
            <app-slide-config
              [config]="config"
              [class]="class"
              [slideConfig]="config['frame-categories__products']"
              [id_object]="objectChoosing._id"
              [device]="device"
            >
            </app-slide-config>
            <div class="config-name title" style="margin-bottom: 15px;">
              <p>{{'cho_phep_tran_vien' | translate}}</p>
              <nz-switch [ngModel]="class['frame-categories']['overflow'] == 'visible'" (ngModelChange)="$event ? class['frame-categories']['overflow'] = 'visible' : class['frame-categories']['overflow'] = 'hidden'; updateClass();"></nz-switch>
            </div>
          </ng-container>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li *ngIf="config['frame-categories__products']['is_autoplay'] || config['frame-categories__products']['is_slide']"
        nz-submenu nzTitle="{{'cau_hinh_icon_trai' | translate}}" [(nzOpen)]="openMenu.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="main-config">
          <!-- Xử lí chọn icon cho icon trái -->
          <app-icon-left-config
                    [device]="device"
                    [class]="class"
                    [config]="config"
                    [iconLeftClass]="class['frame-categories__left-arrow--icon']"
                    [iconLeftConfig]="config['frame-categories__left-arrow--icon']"
                    [distanceLeftClass]="class['frame-categories__left-arrow']"
                    [id_object]="objectChoosing._id"
                >
          </app-icon-left-config>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[2])">{{'mo_rong' | translate}} &#8594;</p>
          </div>

        </div>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li *ngIf="config['frame-categories__products']['is_autoplay'] || config['frame-categories__products']['is_slide']"
        nz-submenu nzTitle="{{'cau_hinh_icon_phai' | translate}}" [(nzOpen)]="openMenu.menu6" (nzOpenChange)="openHandler('menu6')">
        <div class="main-config">
          <!-- Xử lí chọn icon cho icon phải -->
          <app-icon-right-config
                    [device]="device"
                    [class]="class"
                    [config]="config"
                    [iconRightClass]="class['frame-categories__right-arrow--icon']"
                    [iconRightConfig]="config['frame-categories__right-arrow--icon']"
                    [distanceRightClass]="class['frame-categories__right-arrow']"
                    [id_object]="objectChoosing._id"
                >
          </app-icon-right-config>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[3])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Nút phân trang -->
      <li *ngIf="config.type_display == 'pagination'" nz-submenu nzTitle="{{'nut_phan_trang' | translate}}" [(nzOpen)]="openMenu.menu16" (nzOpenChange)="openHandler('menu16')">
        <div class="pl-1" nz-submenu nzTitle="{{'thiet_lap_chung' | translate}}" [(nzOpen)]="openMenu.menu10">
          <div class="editor-field">
            <!-- Ẩn nút phân trang -->
            <div class="config-name" style="padding-bottom:5px">
              <div class="title-font">
                {{'an_nut_phan_trang' | translate}}
              </div>
              <nz-switch [(ngModel)]="config['frame-categories__pagination']['hide_pagination']" (ngModelChange)="class['frame-categories__pagination']['display'] =
                !$event ? 'flex' : 'none';updateConfig();updateClass()"></nz-switch>
            </div>
            <!-- Vị trí cụm nút phân trang -->
            <div>
              <div class="title mb-1 mt-0">{{'vi_tri_cum_nut_phan_trang' | translate}}</div>
              <nz-radio-group style="display:flex; flex-direction:column;"
                [(ngModel)]="class['frame-categories__pagination']['justify-content']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="flex-start">{{'trai' | translate}}</label>
                <label nz-radio nzValue="center">{{'giua' | translate}}</label>
                <label nz-radio nzValue="flex-end">{{'phai' | translate}}</label>
              </nz-radio-group>
            </div>
            <!-- Khoảng cách giữa các nút -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-categories__pagination-list-button']['gap'] | vhnumber"
                  (ngModelChange)="class['frame-categories__pagination-list-button']['gap'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button']['gap'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>

            <!-- Khoảng cách giữa các nút với cột sản phẩm -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut_va_san_pham' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-categories__products']['padding-bottom'] | vhnumber"
                  (ngModelChange)="class['frame-categories__products']['padding-bottom'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-categories__products']['padding-bottom'] | vhnumber"
                (ngModelChange)="class['frame-categories__products']['padding-bottom'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Chỉnh chiều cao của cụm nút phân trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'chieu_cao_cua_cum_nut_phan_trang' | translate}}</p>
                <nz-input-number [nzMin]="50" [nzMax]="100" [nzStep]="1"
                  [ngModel]="class['frame-categories__pagination']['height'] | vhnumber"
                  (ngModelChange)="class['frame-categories__pagination']['height'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="50" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination']['height'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination']['height'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Ẩn nút biểu tượng-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_bieu_tuong' | translate}}</p>
                <nz-switch [ngModel]="config['icon_pagination']['display']" (ngModelChange)="class['frame-categories__pagination-list-button--controll']['display'] =
                                  !$event ? 'flex' : 'none'; config['icon_pagination']['display'] = $event"
                  (nzOnAfterChange)="updateConfig();updateClass()"></nz-switch>
              </div>
            </div>
            <!--Ẩn nút Tới trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_toi_trang' | translate}}</p>
                <nz-switch [(ngModel)]="config['goToPage_pagination']['display']"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
            </div>
            <!-- Chọn Font -->
            <div class="d-flex justify-content-between align-items-center">
              <mat-form-field class="w-100">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['frame-categories__pagination-list-button']['font-family']"
                  (ngModelChange)="updateClass()">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">
                    {{font.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- set HCN hoặc Hình Tròn -->
            <div>
              <div class="config-name mb-0" style="flex-direction: column;">
                <p class="mb-3">{{'kieu_nut_slide' | translate}}</p>
                <nz-radio-group [(ngModel)]="config['slick_dots']['background_style']"
                  (ngModelChange)="handleSetDotsStyle($event)">
                  <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
                  <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
                </nz-radio-group>
                <!-- Kích thước nút (chiều rộng) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'circle'">
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber" (ngModelChange)="handleSetButtonSize($event)"
                      (nzOnAfterChange)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="handleSetButtonSize($event)" (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
                <!-- Kích thước nút (chiều cao) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'rectangle'">
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut_chieu_rong' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut_chieu_cao' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['height'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['height'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- Thiết lập nút chưa chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chua_chon' | translate}}" [(nzOpen)]="openMenu.menu11">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--page-number']['color']"
                [style.background]="class['frame-categories__pagination-list-button--page-number']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--page-number']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--page-number']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--page-number']['border-color']"
                [style.background]="class['frame-categories__pagination-list-button--page-number']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--page-number']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--page-number']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--page-number']['background-color']"
                [style.background]="
                  class['frame-categories__pagination-list-button--page-number']['background-color']
                " [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--page-number']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--page-number']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút được chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_duoc_chon' | translate}}" [(nzOpen)]="openMenu.menu12">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--active']['color']"
                [style.background]="class['frame-categories__pagination-list-button--active']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--active']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--active']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--active']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--active']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--active']['border-color']"
                [style.background]="class['frame-categories__pagination-list-button--active']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--active']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--active']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--active']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--active']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--active']['background-color']"
                [style.background]="class['frame-categories__pagination-list-button--active']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--active']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--active']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--active']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--active']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chuyen_trang' | translate}}" [(nzOpen)]="openMenu.menu13">
          <!-- Sử dụng icon -->
          <div class="item mt-3">
            <div class="title-font">{{'su_dung_icon' | translate}}</div>
            <nz-switch [(ngModel)]="config.icon_pagination.icon" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Kiểu icon -->
          <div class="item">
            <div class="title-font">{{'kieu_icon' | translate}}</div>
            <button [disabled]="!config.icon_pagination.icon" nz-button nz-dropdown [nzDropdownMenu]="menu" style="
                  width: 50%;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                " [nzPlacement]="'bottomCenter'">
              <div style="
                    font-size: 18px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                  ">
                <i [class]="config.icon_pagination.arrow_left_icon"></i>
                <i [class]="config.icon_pagination.arrow_right_icon"></i>
              </div>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let item of bootstrapIconArrows" style="justify-content: center"
                  (click)="onChangeArrows(item)">
                  <div style="
                        font-size: 18px;
                        display: flex;
                        justify-content: space-around;
                        padding: 10px 0px;
                      ">
                    <i [class]="item.icon_left"></i>
                    <i [class]="item.icon_right"></i>
                  </div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="item mt-3">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div *ngIf="!config.icon_pagination.icon" class="field-row my-3">
            
          </div>
          <div class="item">
            <div class="title-font">{{'truoc' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input placeholder="Trước"
              [ngModel]="config.content_pagination['content_left_' + functionService.selectedLanguageCode] | vhLanguage : 'content_left' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_left_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <div class="item">
            <div class="title-font">{{'sau' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input placeholder="Sau"
              [ngModel]="config.content_pagination['content_right_' + functionService.selectedLanguageCode] | vhLanguage : 'content_right' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_right_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--controll']['background-color']"
                [style.background]="class['frame-categories__pagination-list-button--controll']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpPositionOffset]="'-200%'" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--controll']['color']"
                [style.background]="class['frame-categories__pagination-list-button--controll']['color']"
                [cpPosition]="'top'" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--controll']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--controll']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--controll']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--controll']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--controll']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--controll']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--controll']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--controll']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">{{'chon_mau_vien' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-categories__pagination-list-button--controll']['border-color']"
                [style.background]="class['frame-categories__pagination-list-button--controll']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-categories__pagination-list-button--controll']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-categories__pagination-list-button--controll']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-categories__pagination-list-button--controll']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-categories__pagination-list-button--controll']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div *ngIf="!config['goToPage_pagination']['display']" class="px-1 li-config" nz-submenu
          nzTitle="{{'thiet_lap_nut_toi_trang' | translate}}" [(nzOpen)]="openMenu.menu14">

          <div class="item mt-3">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="item">
            <div class="title-font">{{'toi_trang' | translate}}</div>
            <input style="width: 50%" nz-input placeholder="{{'toi_trang' | translate}}"
              [ngModel]="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] | vhLanguage : 'content_goToPage' : objectChoosing.component" 
              (ngModelChange)="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['background_color']"
                [style.background]="config['goToPage_pagination']['background_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['color']"  type="button"
                [style.background]="config['goToPage_pagination']['color']" (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">{{'chon_mau_vien' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['border_color']"
                [style.background]="config['goToPage_pagination']['border_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
        </div>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-total-row-col-products-config
                [config]="config"
                [class]="class"
                [productsClass]="class['frame-categories__products']"
                [productsConfig]="config['frame-categories__products']"
                [id_object]="objectChoosing._id"
                [device]="device"
        >
        </app-total-row-col-products-config>

        <!-- Khoảng đệm -->
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-categories__products']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMenu.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <input class="input-color" [style.background]="class['frame-categories__products--item']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-categories__products--item']['background-color']"  type="button"
              (colorPickerClose)="updateClass()" />
          </div>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
            <p class="discover_text" (click)="openViewAll(stylesField[6])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>

          <app-borders-config [device]="device"
                            [class]="class" [elementChoosing]="objectChoosing"
                            [borderClass]="class['frame-categories__products--item']"
                            [id_object]="objectChoosing._id"
          >
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong: active -->
      <li *ngIf="config.data_type_same_category?.is_highlight_active" nz-submenu
      nzTitle="{{'cau_hinh_phan_tu' | translate}} active" [(nzOpen)]="openMenu.menu15" (nzOpenChange)="openHandler('menu15')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <input class="input-color" [style.background]="class['frame-categories__products--item-active']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-categories__products--item-active']['background-color']"  type="button"
              (colorPickerClose)="updateClass()" />
          </div>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
            <p class="discover_text" (click)="openViewAll(stylesField[8])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>

          <app-borders-config [device]="device"
                            [class]="class" [elementChoosing]="objectChoosing"
                            [borderClass]="class['frame-categories__products--item-active']"
                            [id_object]="objectChoosing._id"
          >
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[7])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [device]="device"
                            [class]="class" [elementChoosing]="objectChoosing"
                            [borderClass]="class['frame-categories']"
                            [id_object]="objectChoosing._id"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li
        nz-submenu
        nzTitle="{{'do_bong' | translate}}"
        [(nzOpen)]="openMenu.menu8"
        (nzOpenChange)="openHandler('menu8')"
      >
        <!-- Đổ bóng -->
        <app-shadow-config
          [device]="device"
          [config]="config"
          [class]="class"
          [shadowClass]="class['frame-categories']"
          [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing"
        >
        </app-shadow-config>
      </li>
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMenu.menu18" (nzOpenChange)="openHandler('menu18')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config
          [device]="device"
          [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" 
          [device]="device" 
          [class]="class" 
          [config]="config"
          [staticdata]="objectChoosing.staticdata" 
          [cursorClass]="class['frame-categories']" 
          [effect_hover]="effect_hover"
          [customize]="customize" 
          [type]="'object'"
          [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['frame-categories']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="[2, 8].includes(currentViewAll.index)">
      <div class="editor-field">
        <app-borders-radius-config
                      [device]="device"
                      [class]="class"
                      [borderRadiusClass]="class['frame-categories__products--item' + (currentViewAll.index == 8 ? '-active' : '')]"
                      [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
        <!-- Bật đổ bóng -->
        <app-shadow-config 
            [device]="device"
            [config]="config"
            [class]="class"
            [shadowClass]="class['frame-categories__products--item' + (currentViewAll.index == 8 ? '-active' : '')]"
            [shadowConfig]="config['frame-categories__products--item' + (currentViewAll.index == 8 ? '-active' : '')]"
            [objectChoosing]="objectChoosing"
            >
        </app-shadow-config>
      </div>
    </div>
    <!-- Icon slide trái -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-config [device]="device"
                          [class]="class" [elementChoosing]="objectChoosing"
                          [borderClass]="class['frame-categories__left-arrow--icon']"
                          [id_object]="objectChoosing._id"
      >
      </app-borders-config>
      <!-- Bo tròn -->
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-categories__left-arrow--icon']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
    <!-- Icon slide phải -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-config [device]="device"
                          [class]="class" [elementChoosing]="objectChoosing"
                          [borderClass]="class['frame-categories__right-arrow--icon']"
                          [id_object]="objectChoosing._id"
      >
      </app-borders-config>
      <!-- Bo tròn -->
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-categories__right-arrow--icon']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div> 
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 5">
      <app-animations-config [staticdata]="objectChoosing.staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="[6, 7, 9].includes(currentViewAll.index)">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config[gradientConfigMap[currentViewAll.index - 1].configKey].gradient_check"
          (ngModelChange)="updateBackgroundRgb(currentViewAll.index - 1)"></label>
      </div>
      <ng-container *ngIf="config[gradientConfigMap[currentViewAll.index - 1].configKey]?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config[gradientConfigMap[currentViewAll.index - 1].configKey]['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i, (currentViewAll.index - 1))" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config[gradientConfigMap[currentViewAll.index - 1].configKey].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" type="button"
            [(colorPicker)]="config[gradientConfigMap[currentViewAll.index - 1].configKey]['background']"
            [disabled]="!config[gradientConfigMap[currentViewAll.index - 1].configKey].gradient_check"
            [style.background]="config[gradientConfigMap[currentViewAll.index - 1].configKey]['background']"
            (colorPickerClose)="addGradient($event, (currentViewAll.index - 1))" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, (currentViewAll.index - 1))"
          [class.active]="config[gradientConfigMap[currentViewAll.index - 1].configKey]['gradient_direction'] === type.direction"
          [disabled]="!config[gradientConfigMap[currentViewAll.index - 1].configKey].gradient_check"
          [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'">
        </button>
      </ng-container>
    </div>
  </div>
</div>